import * as Utils from '../../modules/Utils'

const excludeList = ['Id', 'ParentId', 'ValidTo', 'ValidFrom', 'ManagerId', 'EmployeeId']
const states = {
  'ManagerEmployee-EntityAdded': 'assigned',
  'ManagerEmployee-EntityDeleted': 'unassigned',
  'Employee-EntityAdded': 'added',
  'ManagerHierarchy-EntityAdded': 'added',
  'Employee-EntityDeleted': 'deleted',
  'ManagerHierarchy-EntityDeleted': 'deleted',
  'Employee-EntityModified': 'modified',
  'ManagerHierarchy-EntityModified': 'modified'
}

const getMeta = (props) => {
  return props.reduce((map, item) => {
    const isExcluded = excludeList.indexOf(item.propertyName) !== -1
    if (isExcluded) {
      const oldValue = item.oldValueFormatted
      const newValue = item.newValueFormatted
      return {
        ...map,
        [item.propertyName]: {
          oldValue,
          newValue
        }
      }
    }
    return map
  }, {})
}

const getProperties = (props) => {
  return props.reduce((map, item) => {
    const isExcluded = excludeList.indexOf(item.propertyName) !== -1
    if (!isExcluded) {
      let oldValue
      let newValue
      if (item.propertyName === 'BirthDate') {
        oldValue = item.oldValueFormatted && Utils.dateToString(item.oldValueFormatted)
        newValue = item.newValueFormatted && Utils.dateToString(item.newValueFormatted)
      } else {
        oldValue = item.oldValueFormatted
        newValue = item.newValueFormatted
      }
      return [
        ...map,
        {
          key: item.auditEntryPropertyID !== 0 ? item.auditEntryPropertyID : item.propertyName + Date.now(),
          name: item.propertyName,
          oldValue,
          newValue
        }
      ]
    }
    return map
  }, [])
}

export default (data) => ({
  key: data.auditEntryID,
  entityTypeName: data.entityTypeName,
  stateName: states[`${data.entityTypeName}-${data.stateName}`],
  createdDate: Utils.dateTimeToString(data.createdDate),
  meta: getMeta(data.properties),
  properties: getProperties(data.properties)
})



// WEBPACK FOOTER //
// ./src/api/audit/AuditModel.js